import { Component, OnInit, ViewChild } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { IPtTestList } from "app/models/core/admin/masterTables";
import { ISpecialtyCategory } from "app/models/core/admin/specialtyCategory";
import { IKey, Keys } from "app/models/core/keys";
import { AdminService } from "app/services/admin/admin.service";
import { SharedService } from "app/services/core/shared.service";


@Component({
  selector: 'app-keysModal',
  templateUrl: './keys.component.html',
  styleUrls: ['./keys.component.scss'],
})

export class KeysComponent implements OnInit {

  public keysTab = 0;
  labTypeList: IKey[] = Keys.labType;
  scheduleKeyList: IKey[] = Keys.scheduleKey;
  accreditationKeyList: IKey[] = Keys.accreditationKeys;
  surveysTypesList: IKey[] = Keys.surveyType;
  complexityList: IKey[] = Keys.complexityType;
  certificateTypeList: IKey[] = Keys.certType;
  proficiencyTestList: IPtTestList[] = [];
  specialtiesList: ISpecialtyCategory[] = [];

  displayedColumns: string[] = ['tId', 'ptTest', 'specialty', 'subSpecialty', 'testCode', 'code'];

  dataSource = new MatTableDataSource<IPtTestList>(this.proficiencyTestList);

  listFilter = '';

  @ViewChild('TablePaginator') paginator !: MatPaginator;
  @ViewChild('TableSort') sort!: MatSort;
  
  constructor(private dialogRef: MatDialogRef<KeysComponent>,
    public sharedService: SharedService, public adminService: AdminService) {};

  ngOnInit(): void {
    this.keysTab = 0;

    // Getting PT List
    this.adminService.getPtList().subscribe(
      res => {
        this.proficiencyTestList = res;
        this.dataSource.data = this.proficiencyTestList;
        this.timeout();
      },
      error => console.log('error: ', error),
      () => {
      }
    );

    // Getting Specialties list
    this.adminService.getSpecialtyCategories().subscribe(
      res => {
        this.specialtiesList = res;
      },
      error => console.log('error: ', error),
      () => {
      }
    );

  }

  timeout() {
    setTimeout(() => {
      this.dataSource.sort = this.sort;
    }, 100);
  }

  filterTable(evnt: Event) {
    this.listFilter = (evnt.target as HTMLInputElement).value;
    this.dataSource.filter = this.listFilter.trim().toLowerCase();
  }

  clearFilter() {
    this.listFilter = "";
    this.dataSource.filter = this.listFilter;
  }

  close(): void {
    this.dialogRef.close();
  }
}
